import React from 'react'

import { AppSvg, Button, FormattedHTMLMessage, newIcons, QR, useBreakpoints, useImageSrc } from '@web/walter-ui-kit'
import { useIntl } from 'react-intl'
import s from './s.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'
import { globalLang } from '~globalLang'
import { images } from '~constants/images'

interface Props {
    onClose: () => void
}

function Content({ onClose }: Props) {
    const intl = useIntl()
    const { isMobile, isTablet } = useBreakpoints()

    const { src: svgUrl } = useImageSrc({
        imgName: images.ic72ProductLogo,
        path: 'common',
    })

    return (
        <ModalView
            img={
                <div className={s.icon}>
                    <AppSvg svgName={newIcons.ic80Phone} size={80} path="new-icons" />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.title} />}
            subtitle={!(isMobile || isTablet) ? <FormattedHTMLMessage {...lang.description} /> : undefined}
            dataPointer="block_alert"
        >
            <div className={s.wrap}>
                {!(isMobile || isTablet) && (
                    <div className={s.qrWrap}>
                        <QR svgUrl={svgUrl} data={intl.formatMessage(globalLang.threeDSLink)} size="l" />
                    </div>
                )}
                {!(isMobile || isTablet) ? (
                    <Button dataPointer="cancel" size="l" mode="primary" onClick={onClose} fullWidth>
                        <FormattedHTMLMessage {...lang.ok} />
                    </Button>
                ) : (
                    <Button
                        dataPointer="cancel"
                        size="l"
                        mode="primary"
                        href={intl.formatMessage(globalLang.threeDSLink)}
                        role="anchor"
                        openInCurrentWindow={false}
                        fullWidth
                    >
                        <FormattedHTMLMessage {...lang.open} />
                    </Button>
                )}
            </div>
        </ModalView>
    )
}

export default Content
